import { render, staticRenderFns } from "./InitiateSavings.vue?vue&type=template&id=474f122c&scoped=true&"
import script from "./InitiateSavings.vue?vue&type=script&lang=js&"
export * from "./InitiateSavings.vue?vue&type=script&lang=js&"
import style0 from "./InitiateSavings.vue?vue&type=style&index=0&id=474f122c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474f122c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VContainer,VIcon,VImg,VRow,VSelect,VSwitch})
